import { render } from "./IdlingAgents.vue?vue&type=template&id=4dd952ce"
import script from "./IdlingAgents.vue?vue&type=script&lang=js"
export * from "./IdlingAgents.vue?vue&type=script&lang=js"

import "./IdlingAgents.vue?vue&type=style&index=0&id=4dd952ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__